import React, { createRef } from 'react';
import styled from 'styled-components';
import { node, string, array, number } from 'prop-types';
import Steps from 'apps/journey/pages/my-journey2/steps';
import { resolve } from 'library/helpers/path-resolver';

const LineContainer = styled.div`
  position: relative;
  height: ${(props) => props.height};
  grid-column: 1;
`;

const ConnectingLine = ({ height = '1em' }) => (
  <LineContainer height={height} aria-hidden="true">
    <DottedLine />
  </LineContainer>
);

const DottedLine = styled.div`
  position: absolute;
  width: 0;
  border-left: 4px ${(props) => (props.lineColor ? props.lineColor : '#37b697')}
    dotted;
  height: 100%;
  left: 50%;
  z-index: -1;
`;

const StepContainer = styled.div`
  grid-column-start: 2;
  grid-column-end: 2;
  grid-row-start: ${(props) => props.startAt};
  grid-row-end: ${(props) => props.endAt};
  align-self: start;

  @media all and (max-width: 1280px) {
    grid-column-start: 1;
    grid-column-end: 1;
    grid-row-start: ${(props) => props.startAt + 2};
    grid-row-end: ${(props) => props.startAt + 3};
  }
`;

const StyledComponent = styled.ol`
  justify-items: center;
  display: grid;
  grid-template-columns: 1fr ${(props) => props.activeGoal};
  grid-template-rows: auto;
  transition: width 500ms ease-out;

  @media all and (max-width: 1280px) {
    grid-template-columns: 1fr;
  }
`;

class Connector extends React.Component {
  constructor(props) {
    super(props);

    this.stepsRef = createRef({});
  }

  render() {
    const {
      component = 'ol',
      lineHeight = '2em',
      lineColor,
      children,
      activeGoalId,
      activeOutcomeId,
      outcomes = [],
    } = this.props;

    const outcomeIndex = outcomes.findIndex((c) => c.id == activeOutcomeId);

    return (
      <React.Fragment>
        <StyledComponent
          as={component}
          activeGoal={activeGoalId ? '1fr' : null}
        >
          {React.Children.map(children, (child, i) =>
            <React.Fragment key={i}>
              {child}
              { i < children.length - 1 &&
                <ConnectingLine height={lineHeight} lineColor={lineColor} />
              }
              { activeGoalId && i === outcomeIndex &&
                <StepContainer
                  startAt={outcomeIndex == 0 ? 1 : outcomeIndex * 2 + 1}
                  endAt={outcomes.length * 2 + 1}
                  ref={this.stepsRef}
                >
                  <Steps
                    margin="0 0 0 2em"
                    mobile_margin="2em 0"
                    outcomeId={outcomes[outcomeIndex].id}
                    connectGoal={false}
                    canCloseStepsView={true}
                    goal={resolve(outcomes, `${outcomeIndex}/goals`, []).find(
                      (c) => c.id == activeGoalId
                    )}
                    goalColor={outcomes[outcomeIndex].color}
                  />
                </StepContainer>
              }
            </React.Fragment>
          )}
        </StyledComponent>
      </React.Fragment>
    );
  }
}

Connector.propTypes = {
  component: node,
  lineHeight: string,
  lineColor: string,
  children: node,
  activeGoalId: number,
  outcomes: array,
  activeOutcomeId: number,
};

ConnectingLine.propTypes = {
  height: string,
};

export default Connector;
